import {
	Box,
	LinearProgress,
	Paper,
	Typography,
	useTheme,
} from "@mui/material";
import useStyles from "./styles";
import { QueryStatsOutlined } from "@mui/icons-material";

export default function StatusComponent(params) {
	const { status = true, loading = false } = params;
	const theme = useTheme();
	const styles = useStyles(theme);
	const colorPaper =
		theme.palette.mode === "dark"
			? status === true
				? theme.palette.cardTrafficData.paperColor.statusUp
				: status === false
				? theme.palette.cardTrafficData.paperColor.statusDown
				: theme.palette.grey[800]
			: status === true
			? theme.palette.cardTrafficData.paperColor.statusUp
			: status === false
			? theme.palette.cardTrafficData.paperColor.statusDown
			: theme.palette.grey[300];
	const colorCard =
		theme.palette.mode === "dark"
			? status === true
				? theme.palette.cardTrafficData.containerColorIcon.statusUp
				: status === false
				? theme.palette.cardTrafficData.containerColorIcon.statusDown
				: theme.palette.grey[700]
			: status === true
			? theme.palette.cardTrafficData.containerColorIcon.statusUp
			: status === false
			? theme.palette.cardTrafficData.containerColorIcon.statusDown
			: theme.palette.grey[400];
	const colorIcon =
		theme.palette.mode === "dark"
			? status === true
				? theme.palette.cardTrafficData.iconColor.statusUp
				: status === false
				? theme.palette.cardTrafficData.iconColor.statusDown
				: theme.palette.grey[400]
			: status === true
			? theme.palette.cardTrafficData.iconColor.statusUp
			: status === false
			? theme.palette.cardTrafficData.iconColor.statusDown
			: theme.palette.grey[600];

	return (
		<Paper
			variant={theme.palette.mode === "dark" ? "outlined" : "elevation"}
			elevation={3}
			sx={{
				...styles.containerPaper,
				backgroundColor: colorPaper,
			}}
		>
			{loading && <LinearProgress sx={styles.linearProgress} />}
			<QueryStatsOutlined
				sx={{
					...styles.speedIcon,
					color: colorIcon,
				}}
			/>
			<Box sx={{ width: "100%", display: "flex", justifyContent: "left" }}>
				<Typography sx={styles.titleCard}>Status da interface</Typography>
			</Box>
			<Box sx={styles.containerBodyCard}>
				<Box
					sx={{
						...styles.containerIconCard,
						backgroundColor: colorCard,
					}}
				>
					<QueryStatsOutlined sx={{ fontSize: "20px", color: colorIcon }} />
				</Box>
				<Typography sx={{ ...styles.titleValue, color: colorIcon }}>
					{status === true ? "UP" : status === false ? "DOWN" : "N/A"}
				</Typography>
			</Box>
		</Paper>
	);
}
